import Vue from 'vue'
import Router from 'vue-router'
import Home from "../components/Home";
import Login from "../components/Auth/Login";

Vue.use(Router);

import auth from './middlewares/AuthMiddleware';
import guest from './middlewares/GuestMiddleware';
import subscribed from './middlewares/SubscribedMiddleware';
import notSubscribed from './middlewares/NotSubscribed';
import admin from './middlewares/AdminMiddleware';
import SubscriptionStatusPage from "../components/Account/Children/Subscription/SubscriptionStatusPage";
import Account from "../components/Account/Account";
import store from "../store/store";
import NotificationView from "../components/Notifications/NotificationView";
import ForgotPassword from "../components/Auth/ForgotPassword";
import ResetPassword from "../components/Auth/ResetPassword";
import ChangePassword from "../components/Account/Children/ChangePassword";
import Register from "../components/Auth/Register/Register";
import SubscriptionStepper from "../components/Subscription/Start/SubscriptionStepper";
import Error404 from "../components/ErrorPages/Error404";
import AdminBaseComponent from "../components/Admin/AdminBaseComponent";
import FaqManagement from "../components/Admin/FAQ/FaqManagement";
import FaqCreateEdit from "../components/Admin/FAQ/FaqCreateEdit";
import FrequentlyAskedQuestions from "../components/Account/Children/FAQ/FrequentlyAskedQuestions";
import VideoManagement from "../components/Admin/Video/VideoManagement";
import UploadEditVideo from "../components/Admin/Video/UploadEditVideo";
import Gym from "../components/Gym/Gym";
import AuthRepository from "../repositories/Auth/AuthRepository";
import GymVideo from "../components/Gym/GymVideo";
import CancelSubscription from "../components/Account/Children/Subscription/Cancel/CancelSubscription";
import SubscriptionCanceled from "../components/Account/Children/Subscription/Cancel/SubscriptionCanceled";
import SubscriptionResume from "../components/Account/Children/Subscription/Cancel/SubscriptionResume";
import ShowSeries from "../components/Series/ShowSeries";
import SeriesManagement from "../components/Admin/Series/SeriesManagement";
import SeriesAddUpdate from "../components/Admin/Series/SeriesAddUpdate";
import SeriesVideoManagement from "../components/Admin/Series/SeriesVideoManagement";
import SeriesList from "../components/Series/SeriesList";
import AccountInfo from "../components/Account/Children/AccountInfo";
import AddressManagement from "../components/Account/Children/Address/AddressManagement";
import LockerRoom from "../components/LockerRoom/LockerRoom";
import GetAform from "../components/LockerRoom/SubPages/GetAform";
import MyAform from "../components/LockerRoom/SubPages/MyAform";
import MyCoach from "../components/LockerRoom/SubPages/MyCoach";
import LiveStreamAnnouncementIndex from "../components/Admin/LiveStream/Announcements/LiveStreamAnnouncementIndex";
import LivestreamAnnouncementAddEdit from "../components/Admin/LiveStream/Announcements/LivestreamAnnouncementAddEdit";
import TermsAndConditions from "../components/TermsAndConditions";
import DisplayLivestream from "../components/Livestream/DisplayLivestream";
import AccountUpdateHealthQuestions from "../components/Account/Children/AccountUpdateHealthQuestions";
import UserManagement from "../components/Admin/Users/UserManagement";
import AddressEdit from "../components/Account/Children/Address/AddressEdit";
import User from "../components/Admin/Users/User";
import UserAform from "../components/Admin/Users/Children/UserAform";
import UserInformation from "../components/Admin/Users/Children/UserInformation";
import UserSubscription from "../components/Admin/Users/Children/UserSubscription";
import UserHealthQuestion from "../components/Admin/Users/Children/UserHealthQuestion";
import EquipmentOrdersManagement from "../components/Admin/EquipmentOrders/EquipmentOrdersManagement";
import VideoStats from "../components/Admin/Video/VideoStats";
import Contact from "../components/LockerRoom/SubPages/Contact"
import BlogManagement from "../components/Admin/Blog/BlogManagement";
import BlogPostAddUpdate from "../components/Admin/Blog/BlogPostAddUpdate";
import MyBlog from "../components/LockerRoom/SubPages/MyBlog";
import BlogPost from "../components/Blog/BlogPost";
import SendMessage from "../components/Admin/Messages/SendMessage";
import AttachNewCardToUser from "../components/Subscription/NewCard/AttachNewCardToUser";

let router = new Router({
    linkExactActiveClass: 'active',
    mode: 'history',
    routes: [{
        path: '/api/*'
    },
        {
            path: '/login',
            name: 'login',
            meta: {
                title: 'Login',
                layout: "auth",
                middleware: guest
            },
            component: Login,
        },
        {
            path: '/terms-and-conditions',
            name: 'terms-and-conditions',
            meta: {
                title: 'Terms & Conditions',
                layout: "auth"
            },
            component: TermsAndConditions,
        },
        {
            path: '/register',
            name: 'register',
            meta: {
                title: 'Register',
                layout: "auth",
                middleware: guest
            },
            component: Register,
        },
        {
            path: '/subscription/start',
            name: 'start-subscription',
            meta: {
                title: 'Subscription',
                middleware: [auth, notSubscribed]
            },
            component: SubscriptionStepper,
        },
        {
            path: '/forgot-password',
            name: 'forgot-password',
            meta: {
                title: 'Forgot Password',
                layout: "auth",
                middleware: guest
            },
            component: ForgotPassword,
        },
        {
            path: '/password-reset/:token',
            name: 'reset-password',
            meta: {
                title: 'Reset Password',
                layout: "auth",
                middleware: guest
            },
            component: ResetPassword,
        },
        {
            path: '/',
            alias: '',
            name: 'home',
            redirect: to => {
                if (!store.getters.isAuthenticated)
                    return {
                        name: 'login'
                    };
                if (!store.getters.isSubscribed)
                    return {
                        name: 'subscription'
                    };

                return {
                    name: 'locker.get-aform'
                };
            }
        },
        {
            path: '/locker-room',
            name: 'locker',
            meta: {
                title: 'Locker Room',
                middleware: [auth, subscribed]
            },
            component: LockerRoom,
            children: [
                {
                    path: 'komm-aform',
                    name: 'locker.get-aform',
                    meta: {
                        title: 'Komm AFORM'
                    },
                    component: GetAform,
                },
                {
                    path: 'my-blog',
                    name: 'locker.my-blog',
                    meta: {
                        title: 'My BLOG'
                    },
                    component: MyBlog,
                },
                {
                    path: 'my-blog/:slug',
                    name: 'locker.my-blog.view',
                    meta: {
                        title: 'My BLOG'
                    },
                    component: BlogPost,
                },
                {
                    path: 'my-aform',
                    name: 'locker.my-aform',
                    meta: {
                        title: 'My AFORM'
                    },
                    component: MyAform,
                },
                {
                    path: 'my-coach',
                    name: 'locker.my-coach',
                    meta: {
                        title: 'My COACH'
                    },
                    component: MyCoach,
                },
                {
                    path: 'my-coach/contact',
                    name: 'locker.my-coach.contact',
                    meta: {
                        title: 'Contact'
                    },
                    component: Contact,
                },
            ]
        },
        {
            path: '/account',
            name: 'account',
            meta: {
                title: 'Account',
                middleware: auth
            },
            component: Account,
            children: [{
                path: 'info',
                name: 'account.info',
                meta: {
                    title: 'Account Info'
                },
                component: AccountInfo,
            },
                {
                    path: 'addresses',
                    name: 'account.address',
                    meta: {
                        title: 'Address Management',
                        middleware: subscribed
                    },
                    component: AddressManagement,
                },
                {
                    path: 'addresses/:type/edit',
                    name: 'account.address.edit',
                    meta: {title: 'Edit Address', middleware: subscribed},
                    component: AddressEdit,
                },
                {
                    path: 'change-password',
                    name: 'account.password.change',
                    meta: {
                        title: 'Change Password'
                    },
                    component: ChangePassword,
                },
                {
                    path: 'faq',
                    name: 'account.faq',
                    meta: {
                        title: 'Frequently asked Questions'
                    },
                    component: FrequentlyAskedQuestions,
                },
                {
                    path: 'health-and-goals',
                    name: 'account.health',
                    meta: {
                        title: 'Goals & Your Health',
                        middleware: subscribed
                    },
                    component: AccountUpdateHealthQuestions,
                },
                {
                    path: 'subscription',
                    name: 'subscription',
                    meta: {
                        title: 'Subscription',
                        middleware: auth
                    },
                    component: SubscriptionStatusPage,
                },
                {
                    path: 'subscription/cancel',
                    name: 'cancel-subscription',
                    meta: {
                        title: 'Cancel Subscription',
                        middleware: [auth, subscribed]
                    },
                    component: CancelSubscription,
                },
                {
                    path: 'subscription/cancel/done',
                    name: 'cancel-subscription-done',
                    meta: {
                        title: 'Canceled Subscription',
                        middleware: [auth, subscribed]
                    },
                    component: SubscriptionCanceled,
                },
                {
                    path: 'subscription/resume',
                    name: 'resume-subscription',
                    meta: {
                        title: 'Resume Subscription',
                        middleware: [auth, subscribed]
                    },
                    component: SubscriptionResume,
                },
                {
                    path: 'subscription/update',
                    name: 'update-subscription',
                    meta: {
                        title: 'Update Subscription',
                        middleware: [auth, subscribed]
                    },
                    component: AttachNewCardToUser,
                }
            ]
        },
        {
            path: '/live',
            name: 'gym.live',
            meta: {
                title: 'Live GYM',
                middleware: [auth, subscribed]
            },
            component: DisplayLivestream,
        },
        {
            path: '/gym',
            name: 'gym.index',
            meta: {
                title: 'Gym',
                middleware: [auth, subscribed]
            },
            component: Gym,
        },
        {
            path: '/gym/:video',
            name: 'gym.video',
            meta: {
                title: 'Gym',
                middleware: [auth, subscribed]
            },
            component: GymVideo,
        },
        {
            path: '/series',
            name: 'series.index',
            meta: {
                title: 'Series',
                middleware: [auth, subscribed]
            },
            component: SeriesList,
        },
        {
            path: '/series/:slug',
            name: 'series.show',
            meta: {
                title: 'Series',
                middleware: [auth, subscribed]
            },
            component: ShowSeries,
        },
        {
            path: '/notifications',
            name: 'notifications',
            meta: {
                title: 'Notifications',
                middleware: [auth]
            },
            component: NotificationView,
        },
        {
            path: '/admin',
            meta: {
                middleware: [auth, admin]
            },
            component: AdminBaseComponent,
            children: [
                {
                    path: 'messages',
                    name: 'admin.messages.send',
                    meta: {
                        title: 'Send Message'
                    },
                    component: SendMessage,
                },
                {
                path: 'livestream/announcement',
                name: 'admin.livestream.announcement.index',
                meta: {
                    title: 'Livestream Announcement Management'
                },
                component: LiveStreamAnnouncementIndex,
            },
                {
                    path: 'livestream/announcement/add',
                    name: 'admin.livestream.announcement.add',
                    meta: {
                        title: 'Add Livestream Announcement'
                    },
                    component: LivestreamAnnouncementAddEdit,
                },
                {
                    path: 'livestream/announcement/:announcement/edit',
                    name: 'admin.livestream.announcement.edit',
                    meta: {
                        title: 'Edit Livestream Announcement'
                    },
                    component: LivestreamAnnouncementAddEdit,
                },
                {
                    path: 'blog',
                    name: 'admin.blog.index',
                    meta: {
                        title: 'Blog Management'
                    },
                    component: BlogManagement,
                },
                {
                    path: 'blog/post/:postId/edit',
                    name: 'admin.blog.edit',
                    meta: {
                        title: 'Edit Blog Post'
                    },
                    component: BlogPostAddUpdate,
                },
                {
                    path: 'blog/post/create',
                    name: 'admin.blog.create',
                    meta: {
                        title: 'Create Blog Post'
                    },
                    component: BlogPostAddUpdate,
                },
                {
                    path: 'video',
                    name: 'admin.video.index',
                    meta: {
                        title: 'Video Management'
                    },
                    component: VideoManagement,
                },
                {
                    path: 'video/:video/stats',
                    name: 'admin.video.stats',
                    meta: {
                        title: 'Video Statistics'
                    },
                    component: VideoStats,
                },
                {
                    path: 'video/upload',
                    name: 'admin.video.upload',
                    meta: {
                        title: 'Video Upload'
                    },
                    component: UploadEditVideo,
                },
                {
                    path: 'video/:video/edit',
                    name: 'admin.video.edit',
                    meta: {
                        title: 'Edit Video'
                    },
                    component: UploadEditVideo,
                },
                {
                    path: 'series',
                    name: 'admin.series.index',
                    meta: {
                        title: 'Series Management'
                    },
                    component: SeriesManagement,
                },
                {
                    path: 'series/:slug/edit',
                    name: 'admin.series.edit',
                    meta: {
                        title: 'Edit Series'
                    },
                    component: SeriesAddUpdate,
                },
                {
                    path: 'series/:slug/videos',
                    name: 'admin.series.videos',
                    meta: {
                        title: 'Edit Series'
                    },
                    component: SeriesVideoManagement,
                },
                {
                    path: 'series/create',
                    name: 'admin.series.create',
                    meta: {
                        title: 'Create Series'
                    },
                    component: SeriesAddUpdate,
                },
                {
                    path: 'faq',
                    name: 'admin.faq.index',
                    meta: {
                        title: 'FAQ Management'
                    },
                    component: FaqManagement,
                },
                {
                    path: 'faq/create',
                    name: 'admin.faq.create',
                    meta: {
                        title: 'Crete FAQ'
                    },
                    component: FaqCreateEdit,
                },
                {
                    path: 'faq/:question/edit',
                    name: 'admin.faq.edit',
                    meta: {
                        title: 'Edit FAQ'
                    },
                    component: FaqCreateEdit,
                },
                {
                    path: 'user',
                    name: 'admin.user.index',
                    meta: {
                        title: 'User Management'
                    },
                    component: UserManagement,
                },
                {
                    path: 'user/:user',
                    name: 'admin.user',
                    meta: {
                        title: 'User Account'
                    },
                    component: User,
                    children: [{
                        path: 'info',
                        name: 'admin.user.info',
                        meta: {
                            title: 'User Info'
                        },
                        component: UserInformation,
                    }, {
                        path: 'aform',
                        name: 'admin.user.aform',
                        meta: {
                            title: 'User AFORM'
                        },
                        component: UserAform,
                    },
                        {
                            path: 'subscription',
                            name: 'admin.user.subscription',
                            meta: {
                                title: 'User Subscription'
                            },
                            component: UserSubscription,
                        },
                        {
                            path: 'health-and-goals',
                            name: 'admin.user.health',
                            meta: {
                                title: 'Goals & Health'
                            },
                            component: UserHealthQuestion,
                        },
                    ]

                },
                {
                    path: 'equipment-orders',
                    name: 'admin.orders.index',
                    meta: {
                        title: 'Equipment Orders'
                    },
                    component: EquipmentOrdersManagement
                }

            ]
        },
        // Catch All
        {
            path: '/*',
            name: 'error-404',
            meta: {
                layout: "error",
                title: 'Not found'
            },
            component: Error404
        }
    ]
});


/*
    Middleware Bootstrap
 */

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    // If no subsequent Middleware exists,
    // the default `next()` callback is returned.
    if (!subsequentMiddleware) return context.next;

    return (...parameters) => {
        // Run the default Vue Router `next()` callback first.
        context.next(...parameters);
        // Then run the subsequent Middleware with a new
        // `nextMiddleware()` callback.
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({
            ...context,
            next: nextMiddleware
        });
    };
}

router.beforeEach((to, from, next) => {
    store.dispatch('CANCEL_PENDING_REQUESTS');
    // Reset request counter showing loading indicator.
    store.commit('resetLoadingStack');

    if (store.getters.shouldFetchAuthDetails) {
        AuthRepository
            .fetchAuthDetails();
    }

    store.commit('changeRoute');

    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title + ' - AFORM';

    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ?
            to.meta.middleware : [to.meta.middleware];

        const context = {
            from,
            next,
            router,
            to,
        };
        const nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0]({
            ...context,
            next: nextMiddleware
        });
    }

    return next();
});


export default router;
